/**
 * 根据路由生成面包屑（首页不展示，由组件侧判断）
 * @param {import('vue-router').Route} route
 * @returns {{ text: string, path: string | null }[]}
 */
export function getBreadcrumbItems(route) {
	const home = { text: 'Home', path: '/' };
	const blog = { text: 'Blog', path: '/blog/' };
	const name = route.name;

	const map = {
		download: [home, { text: 'Download', path: null }],
		'privacy-policy': [home, { text: 'Privacy Policy', path: null }],
		disclaimer: [home, { text: 'Disclaimer', path: null }],
		'contact-us': [home, { text: 'Contact Us', path: null }],
		blog: [home, { text: 'Blog', path: null }],
		'gbwhatsapp-banned-problem-fix': [
			home,
			blog,
			{ text: 'Banned Problem Fix', path: null },
		],
		'backup-gbwhatsapp-chats-to-google-drive': [
			home,
			blog,
			{ text: 'Backup to Google Drive', path: null },
		],
		'gb-whatsapp-apk-for-pc-windows': [
			home,
			{ text: 'GB WhatsApp for PC', path: null },
		],
		'gb-whatsapp-for-ios': [home, { text: 'GB WhatsApp for iOS', path: null }],
		'gb-whatsapp-old-versions': [home, { text: 'Old Versions', path: null }],
		'how-to-reduce-gb-whatsapp-storage-usage': [
			home,
			blog,
			{ text: 'Reduce Storage Usage', path: null },
		],
		'gb-whatsapp-vs-telegram': [
			home,
			blog,
			{ text: 'GB WhatsApp vs Telegram', path: null },
		],
		'gbwhatsapp-vs-official-whatsapp-2026': [
			home,
			blog,
			{ text: 'GBWhatsApp vs Official WhatsApp', path: null },
		],
	};

	if (map[name]) {
		return map[name];
	}

	const fallback =
		(route.meta && route.meta.title && String(route.meta.title).slice(0, 48)) ||
		'Page';
	return [home, { text: fallback, path: null }];
}
